<template>
  <footer>
    <div class="inner">
      <nav>
        <router-link to="/" v-if="favorites">
          <div class="icon">
            <svg width="26" height="22" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.35 2.064c2.92 2.753 2.92 7.216 0 9.968L12.77 22 2.191 12.032C-.73 9.28-.73 4.817 2.191 2.064c2.921-2.752 7.658-2.752 10.58 0 2.92-2.752 7.657-2.752 10.578 0zM6.391 8.08l6.603 6 6.603-6a1.142 1.142 0 0 0 0-1.723A1.39 1.39 0 0 0 18.651 6a1.39 1.39 0 0 0-.949.357l-4.707 4.277-4.707-4.277A1.39 1.39 0 0 0 7.34 6a1.39 1.39 0 0 0-.948.357 1.142 1.142 0 0 0 0 1.723z" fill="#a9a9a9" fill-rule="evenodd"/>
            </svg>
          </div>
          <div class="label">Favorieten</div>
        </router-link>
        <router-link to="/stops" v-if="stops">
          <div class="icon">
            <svg width="21" height="16" xmlns="http://www.w3.org/2000/svg">
              <g fill="#a9a9a9" fill-rule="evenodd">
                <path d="M2.007 4h-.014C.893 4 0 3.105 0 2s.892-2 1.993-2h.014C3.107 0 4 .895 4 2s-.892 2-1.993 2M18.965 4H9.202c-1.124 0-2.035-.895-2.035-2s.91-2 2.035-2h9.763C20.089 0 21 .895 21 2s-.911 2-2.035 2M2.007 10h-.014C.893 10 0 9.105 0 8s.892-2 1.993-2h.014C3.107 6 4 6.895 4 8s-.892 2-1.993 2M18.965 10H9.202c-1.124 0-2.035-.895-2.035-2s.91-2 2.035-2h9.763C20.089 6 21 6.895 21 8s-.911 2-2.035 2M2.007 16h-.014C.893 16 0 15.105 0 14s.892-2 1.993-2h.014C3.107 12 4 12.895 4 14s-.892 2-1.993 2M18.965 16H9.202c-1.124 0-2.035-.895-2.035-2s.91-2 2.035-2h9.763c1.124 0 2.035.895 2.035 2s-.911 2-2.035 2"/>
              </g>
            </svg>
          </div>
          <div class="label">Routes</div>
        </router-link>
        <router-link to="/maps" v-if="maps">
          <div class="icon">
            <svg width="21" height="16" xmlns="http://www.w3.org/2000/svg">
              <g fill="#a9a9a9" fill-rule="evenodd">
                <path d="M2.007 4h-.014C.893 4 0 3.105 0 2s.892-2 1.993-2h.014C3.107 0 4 .895 4 2s-.892 2-1.993 2M18.965 4H9.202c-1.124 0-2.035-.895-2.035-2s.91-2 2.035-2h9.763C20.089 0 21 .895 21 2s-.911 2-2.035 2M2.007 10h-.014C.893 10 0 9.105 0 8s.892-2 1.993-2h.014C3.107 6 4 6.895 4 8s-.892 2-1.993 2M18.965 10H9.202c-1.124 0-2.035-.895-2.035-2s.91-2 2.035-2h9.763C20.089 6 21 6.895 21 8s-.911 2-2.035 2M2.007 16h-.014C.893 16 0 15.105 0 14s.892-2 1.993-2h.014C3.107 12 4 12.895 4 14s-.892 2-1.993 2M18.965 16H9.202c-1.124 0-2.035-.895-2.035-2s.91-2 2.035-2h9.763c1.124 0 2.035.895 2.035 2s-.911 2-2.035 2"/>
              </g>
            </svg>
          </div>
          <div class="label">Kaart</div>
        </router-link>
        <router-link to="/feedback" v-if="feedback">
          <div class="icon">
            <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.097 8.588c-.062.124-.098.137-.224.089-.148-.058-.288-.16-.465-.344-.737-.758-1.306-1.681-1.74-2.82-.37-.977-.543-1.868-.523-2.724.006-.26.04-.428.113-.56.03-.05.045-.076.069-.084.022-.008.051-.002.104.015.136.04.265.124.422.271.693.653 1.23 1.472 1.688 2.576.034.079.062.16.09.241l.046.13c.356.957.524 1.837.516 2.694-.002.231-.031.386-.096.516m-.851-6.943A4.125 4.125 0 0 0 11.89.585c-.317-.15-.649-.196-.992-.197l-.31.113C9.067 1.818 7.577 3.168 6.08 4.51 4.746 5.706 3.403 6.894 2.083 8.108c-.462.425-.957.605-1.562.444-.555-.149-.296 1.172-.242 1.4a3.75 3.75 0 0 0 .877 1.66c.124.134.446.47.583.185.049-.104.131-.194.202-.286.26-.338.607-.502 1.031-.524 3.767-.192 7.535-.392 11.303-.576.636-.03 1.024-.352 1.251-.906.283-.695.302-1.426.205-2.154-.283-2.137-1.071-4.061-2.485-5.706m-4.837 10.32c-.081.251-.3.36-.566.373-.391.019-.782.039-1.172.069-.291.021-.539-.071-.652-.336-.177-.413-.46-.536-.887-.464-.263.044-.537.03-.84.044.345.534.656 1.034.988 1.522.178.262.455.378.77.365.836-.038 1.672-.08 2.507-.127.367-.02.656-.187.805-.523.217-.49.404-.995.597-1.474-.165.007-.427.045-.682.02-.437-.043-.725.091-.868.531" fill="#999" fill-rule="nonzero"/>
            </svg>
          </div>
          <div class="label">Feedback</div>
        </router-link>
      </nav>
      <lama-lama class="lamalama" />
    </div>
  </footer>
</template>

<script>
import LamaLama from '@/components/LamaLama'

export default {
  components: {
    LamaLama
  },
  data() {
    return {
      favorites: true,
      stops: true,
      maps: false,
      feedback: true
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 90;
  width: 100%;
  background: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .inner {
    position: relative;
  }

  nav {
    display: flex;
    justify-content: space-between;

    a {
      height: 60px;
      flex: 1;
      text-align: center;

      &.router-link-exact-active {
        .icon svg {
          g,
          path {
            fill: #F5A623;
          }
        }

        .label {
          color: #F5A623;
        }
      }
    }

    .icon {
      height: 22px;
      margin: 12px 0 6px;
    }

    .label {
      font-weight: 500;
      font-size: 9px;
      letter-spacing: 0.5px;
      text-align: center;
      text-transform: uppercase;
      color: #a9a9a9;
    }
  }

  @media screen and (max-height: 666px) {
    .lamalama {
      display: none;
    }
  }
}
</style>
